// components/CompositeGraphRouter.js - Routes to the appropriate composite graph component
import React from 'react';
import SensorCompositeGraph from './SensorCompositeGraph';
import BME688CompositeGraph from './BME688CompositeGraph';

export default function CompositeGraphRouter({ boxId, sensorName, sensorData, onBack }) {
  console.log('🔀 CompositeGraphRouter:', { boxId, sensorName, sensorData });

  // Route BME688 to its specialized component
  if (sensorName === 'bme688' || sensorName.startsWith('bme688-')) {
    return (
      <BME688CompositeGraph
        boxId={boxId}
        sensorName={sensorName}
        onBack={onBack}
      />
    );
  }

  // Route all other sensors to the standard composite graph
  return (
    <SensorCompositeGraph
      boxId={boxId}
      sensorName={sensorName}
      onBack={onBack}
    />
  );
}